<template>
<div class="mt-5" data-component="FilterDetailsCustomize.vue">
	<div class="flex h-0 justify-center items-center self-stretch"/>

	<div class="text-xl font-bold mt-3" v-html="`Dopasuj ${selectedFilter.type === 'automatic' ? 'Polecanie' : 'Szybki kontakt'}`"/>

	<div v-if="selectedFilter.type === 'automatic'">
		Możesz zdecydować, do jakich zleceń będzie polecana Twoja firma.
		Jeśli nic nie zmienisz, ustawienia będą takie same, jak dla całej usługi.
	</div>

	<div class="divide-neutral-100 divide-y mt-6">
		<!-- Filtry -->
		<div
			class="group flex items-center py-3 cursor-pointer"
			@click="editMatching"
		>
			<BaseIcon :name="`filter-matching`" size="1.5" class="text-neutral-700 group-hover:text-accent mr-3"/>
			<div>
				<div class="font-bold text-base">
					Filtry dla {{ selectedFilter.type === 'automatic' ? 'Polecania' : 'Szybkiego kontaktu' }}
				</div>
				<div class="text-neutral-700">
					Cechy zleceń, do których Cię polecimy
				</div>
			</div>
			<BaseIcon name="chevron-right" size="0.75" class="text-neutral-300 ml-auto"/>
		</div>
		<!-- Filtry -->
		<div
			class="group flex items-center py-3 cursor-pointer"
			@click="editLocations({ filter: selectedFilter, display: true })"
		>
			<BaseIcon :name="`filter-location`" size="1.5" class="text-neutral-700 group-hover:text-accent mr-3"/>
			<div>
				<div class="font-bold text-base" v-html="`Lokalizacja dla ${selectedFilter.type === 'automatic' ? 'Polecania' : 'Szybkiego kontaktu'}`"/>
				<div class="text-neutral-700" v-html="'Obszar, w którym Cię polecimy'"/>
			</div>
			<BaseIcon name="chevron-right" size="0.75" class="text-neutral-300 ml-auto"/>
		</div>
	</div>
</div>
</template>
<script lang="ts">
import { PropType } from 'vue';
import Filter from '../../../../types/interfaces/services/Filter';

export default {
	name: 'FilterDetailsCustomize',
	props: {
		/**
         * Filtr, którego szczegóły są wyświetlane.
         */
		selectedFilter: {
			type: Object as PropType<Filter>,
			required: true,
		},
	},
	emits: ['edit-matching', 'edit-locations'],
	methods: {
		/**
		 * Przenosi użytkownika do edycji Lokalizacji
		 * @emits editLocations
		 */
		editLocations({ filter, display }: { filter: Filter, display: boolean }) {
			this.$emit('edit-locations', { filter, display });
		},

		/**
		 * Przenosi użytkownika do edycji Filtrów
		 * @emits editMatching
		 */
		editMatching() {
			this.$emit('edit-matching');
		},
	},
};
</script>
